import {useEffect, useRef} from 'react';
export const poundsToPence = price => Math.round(price * 100);
export const penceToPounds = price => Number((price / 100).toFixed(2));
export const applyVat = price => price * 1.2;
export const substractVat = price => price / 1.2;

export const hitKeyESC = () => {
  const escEvent = new KeyboardEvent('keydown', {
    key: 27,
    keyCode: 27,
  });
  document.dispatchEvent(escEvent);
};

export const httpGetAsync = (theUrl, callback) => {
  const xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function() {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200) callback(xmlHttp.responseText);
  };
  xmlHttp.open('GET', theUrl, true);
  xmlHttp.send(null);
};

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
